import { render } from "./GuideResult.vue?vue&type=template&id=4bdd1fcd"
import script from "./GuideResult.vue?vue&type=script&lang=js"
export * from "./GuideResult.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__